/**
 * Whether a Firestore error is a security-rules denial. This is also exactly
 * what a query against a collection with no deployed rules returns (rules
 * default-deny), so "collection doesn't exist backend-side yet" surfaces as a
 * permission error — see NOT_YET_PROJECTED in firestore/collections.ts.
 */
export function isPermissionError(error: Error): boolean {
  return /permission|insufficient|PERMISSION_DENIED/i.test(error.message);
}

/**
 * Whether a Firestore error is "this query has no composite index". The SDK reports it as
 * FAILED_PRECONDITION with a message carrying a create-index link. It means the environment is
 * missing an index the code expects — NOT that the data is absent — so a surface that derives a
 * number from such a query must report the gap rather than render a partial answer.
 */
export function isMissingIndexError(error: Error): boolean {
  return /requires an index|failed[- ]precondition/i.test(error.message);
}
